import { Faqs } from "@/components/landing/faqs";

export type FaqEntry = { q: string; a: string };

/**
 * FAQ rendered from the `posts.faq` jsonb column, using the shared v3 FAQ
 * accordion (answers stay in the server HTML for crawlers).
 */
export function PostFaq({ items }: { items: FaqEntry[] }) {
  if (items.length === 0) return null;
  return (
    <section aria-labelledby="faq-heading" className="mt-14">
      <h2 id="faq-heading" className="font-display text-2xl font-extrabold text-foreground">
        أسئلة شائعة
      </h2>
      <div className="mt-5">
        <Faqs items={items} />
      </div>
    </section>
  );
}
